
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sian",
      function () {
        return require("private-next-pages/sian.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sian"])
      });
    }
  